import { render, staticRenderFns } from "./TrStepByStepComics.vue?vue&type=template&id=48e06170&scoped=true&"
import script from "./TrStepByStepComics.vue?vue&type=script&lang=js&"
export * from "./TrStepByStepComics.vue?vue&type=script&lang=js&"
import style0 from "./TrStepByStepComics.vue?vue&type=style&index=0&id=48e06170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e06170",
  null
  
)

export default component.exports